module.exports = __webpack_public_path__ + "static/logo-2ee11ffea58b360ca726fe487899b513.png";